<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        title="会议室详情"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12">
                        <div class="label">会议室名称：</div>
                        <div class="content">{{ msg.name }}</div>
                    </el-col>
                    <el-col :span="12" v-if="detailVisible">
                        <div class="label">会议室说明：</div>
                        <div class="content">{{ msg.desc }}</div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            msg:{}
        };
    },
    props: {
        detailVisible: Boolean,
        cellItem: Object
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                    this.meetingLookUpRoom();
                }
            }
        }
    },
    created() {},
    methods: {
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        meetingLookUpRoom() {
            oaApi
                .meetingLookUpRoom({ id: this.cellItem.id }, "get")
                .then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.msg = res.data;
                    }
                });
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
